<template>
  <div class="card-207 border">
    <m-img class="card-207-img" :src="image" :alt="alt"/>
    <div class="row mx-auto mt-2">
      <div class="col-12 text-center p-1 ">
        <slot name="p-1">
          <p class="mt-3 p-0 card-207-title  text-center col-12">
            گوشی موبایل اپل مدل iPhone 13 CH/A Not Active ظرفیت 128
          </p>
        </slot>
      </div>

      <div class="col-12 text-center p-0 my-3">
        <slot name="p-2">
          <del class="text-danger">43,399,000</del>
          <span class="bg-danger px-2 py-1 text-white radius-class ml-3">%2</span>
        </slot>
      </div>

    </div>
    <div class="card207-parent-icon w-100  mx-10px text-center">
      <slot name="p-3">
        مشاهده
      </slot>
    </div>
  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card207",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },

}

</script>

<style scoped>
.card-207 {
  height: 330px;
  position: relative;
  border-radius: 0.5rem; /* 8px */
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}

.card-207 * {
  font-size: 13px;
  -webkit-line-clamp: 2;
}

.card-207-img {
  object-fit: contain;
  width: 100%;
  height: 160px;
  margin-top: 15px;
  border-top-left-radius: 0.5rem; /* 8px */
  border-top-right-radius: 0.5rem; /* 8px */
  aspect-ratio: 1/1;
}

.card207-parent-icon {
  position: absolute;
  bottom: 15px;
  right: 0;
}

.radius-class {
  border-radius: 9px;
}
</style>